import Vue from 'vue'

export default {
  store (data) {
    return Vue.http.post('/withdrawals', data)
  },

  update (id, data) {
    return Vue.http.patch(`/withdrawals/${id}`, data)
  }
}
